import { useState, useEffect } from 'react'
import { FiRefreshCw, FiInfo } from 'react-icons/fi'
import api from '../utils/api'

const fmtNum = (v) => v == null ? '—' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const fmtInt = (v) => Number(v || 0).toLocaleString('tr-TR')
const fmtTL = (v) => v == null ? '—' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' ₺'
const fmtPct = (v) => v == null ? '—' : Number(v).toLocaleString('tr-TR', { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + ' %'
const fmtCell = (v, fmt) => {
  if (v == null) return '—'
  if (fmt === 'tl' || fmt === 'money') return fmtTL(v)
  if (fmt === 'int') return fmtInt(v)
  if (fmt === 'num') return fmtNum(v)
  if (fmt === 'pct') return fmtPct(v)
  if (fmt === 'lt') return fmtNum(v) + ' Lt'
  return String(v)
}

const ROW_BG = {
  danger: 'bg-red-50 dark:bg-red-900/20',
  orange: 'bg-orange-50 dark:bg-orange-900/20',
  yellow: 'bg-yellow-50 dark:bg-yellow-900/20',
  green:  'bg-green-50 dark:bg-green-900/20',
}

export default function AITahmin() {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [openInfo, setOpenInfo] = useState({})

  const load = async () => {
    setLoading(true)
    try {
      const { data } = await api.get('/ai-tahmin')
      setData(data)
    } catch (e) { console.error(e) }
    setLoading(false)
  }
  useEffect(() => { load() }, [])

  return (
    <div className="p-3 md:p-5">
      <div className="sticky top-0 z-20 -mx-3 md:-mx-5 px-3 md:px-5 py-3 mb-4 bg-gray-50/95 dark:bg-gray-900/95 backdrop-blur border-b border-gray-200 dark:border-gray-700 flex items-center justify-between gap-2 flex-wrap">
        <div className="min-w-0">
          <h1 className="text-lg md:text-xl font-bold text-gray-800 dark:text-gray-100">🔮 Yapay Zeka Tahmin</h1>
          <p className="text-[10px] md:text-xs text-gray-500 dark:text-gray-400 truncate">Geleceğe dönük projeksiyon ve tahmin · {data && new Date(data.generated_at).toLocaleString('tr-TR')}</p>
        </div>
        <button onClick={load} disabled={loading} className={`p-2 rounded-lg ${loading ? 'text-primary-400' : 'text-gray-500 hover:text-primary-600 hover:bg-primary-50 dark:hover:bg-gray-800'}`}>
          <FiRefreshCw size={16} className={loading ? 'animate-spin' : ''} />
        </button>
      </div>

      {loading && !data && <div className="text-center py-20 text-gray-400">Tahmin hesaplanıyor...</div>}

      {data?.sections?.map((sec, i) => (
        <div key={i} className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 p-4 mb-4">
          <h2 className="text-sm font-semibold text-gray-800 dark:text-gray-100 mb-3 pb-2 border-b dark:border-gray-700">{sec.title}</h2>
          {sec.kpis && sec.kpis.length > 0 && (
            <div className={`grid grid-cols-2 gap-3 mb-4 ${
              sec.kpis.length >= 6 ? 'md:grid-cols-6' :
              sec.kpis.length === 5 ? 'md:grid-cols-5' :
              sec.kpis.length === 4 ? 'md:grid-cols-4' :
              sec.kpis.length === 3 ? 'md:grid-cols-3' : 'md:grid-cols-2'
            }`}>
              {sec.kpis.map((kpi, j) => (
                <div key={j} className="bg-gradient-to-br from-primary-50 to-white dark:from-primary-900/30 dark:to-gray-900 rounded-lg p-3 border border-primary-100 dark:border-primary-800">
                  <div className="text-[10px] text-gray-500 dark:text-gray-400 uppercase tracking-wide font-medium">{kpi.label}</div>
                  <div className="text-xl font-bold text-primary-700 dark:text-primary-300 mt-1">{fmtCell(kpi.value, kpi.format)}</div>
                </div>
              ))}
            </div>
          )}
          {(sec.tables || []).map((tbl, j) => (
            <div key={j} className="mt-3">
              <div className="flex items-center gap-2 mb-2">
                <h3 className="text-xs font-medium text-gray-600 dark:text-gray-300 flex-1">{tbl.title}</h3>
                {tbl.info && (
                  <button onClick={() => setOpenInfo(p => ({...p, [`${i}-${j}`]: !p[`${i}-${j}`]}))}
                    className="text-gray-400 hover:text-blue-600 p-1"><FiInfo size={12}/></button>
                )}
              </div>
              {openInfo[`${i}-${j}`] && tbl.info && (
                <div className="mb-2 bg-blue-50 dark:bg-blue-900/20 border-l-2 border-blue-400 px-3 py-2 text-[11px] text-gray-700 dark:text-gray-300 whitespace-pre-line rounded-r">{tbl.info}</div>
              )}
              {tbl.rows.length === 0 ? (
                <p className="text-xs text-gray-400 italic">Veri yok</p>
              ) : (
                <div className="overflow-auto max-h-[60vh] border border-gray-100 dark:border-gray-700 rounded">
                  <table className="w-full text-xs anlik-table">
                    <thead className="sticky top-0 z-20">
                      <tr className="bg-gray-50 dark:bg-gray-700">
                        {tbl.columns.map((c, ci) => (
                          <th key={c.key} className={`px-2 py-1.5 text-left font-medium text-gray-600 dark:text-gray-300 ${c.format ? 'text-right' : ''} bg-gray-50 dark:bg-gray-700 ${ci === 0 ? 'sticky left-0 z-30' : ''}`}>{c.label}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {tbl.rows.map((row, k) => {
                        const rowBg = ROW_BG[row._row_color] || ''
                        return (
                          <tr key={k} className={`border-b border-gray-50 dark:border-gray-700 ${rowBg}`}>
                            {tbl.columns.map((c, ci) => (
                              <td key={c.key} className={`px-2 py-1 text-gray-700 dark:text-gray-300 ${c.format ? 'text-right tabular-nums' : ''} ${ci === 0 ? `sticky left-0 z-[1] ${rowBg || 'bg-white dark:bg-gray-800'}` : ''}`}>
                                {fmtCell(row[c.key], c.format)}
                              </td>
                            ))}
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}
